<div id="wrapper">
    <div>
        <app-menu [tabActive]="this.tabActive" [showUserMobile]="this.global.showUserMobile"></app-menu>
    </div>
    <div>
        <app-tab-nav
            [visible]="false"
            (updatePostpaid)="this.postpago=$event"
            (updatePrepaid)="this.prepago=$event"
            (updateFixed)="this.telefoniaFijo=$event"
            (updateTotalAccountList)="this.totalAccountList=$event"
            (updateCurrentList)="this.currentList=$event"
            (updateSelectBan)="this.selectBan=$event"
            (updateInitializeData)="this.initializeData()">
        </app-tab-nav>
    </div>
    <div class="allcont logsize m-top-i">
        <div class="basicrow ">
            <div class="container">
                <div class="">
                    <div class="fulltitle  f-btitle autodef">
                        <span class="icon-dash-27"></span> Netflix
                    </div>
                </div>
            </div>
        </div>
        <div class="basicrow m-top">
            <div class="container">
                <a class="webW" (click)="this.changeView('init', 'step1')"><img width="100%" src="../assets/images/banner-netflix.jpg"></a>
                <a class="movilB" (click)="this.changeView('init', 'step1')"><img width="100%" src="../assets/images/banner-netflix-movil.jpg"></a>
            </div>
        </div>
        <div class="basicrow m-top lessm">
            <div class="container">
                <div class="basicrow m-top-i">
                    <div class="row">
                        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 roboto-l f-black text-justify">
                            <span class="f-big less-f">&#191;Qu&eacute; es el Servicio Netflix&#63;</span><br /><br />
                            <span class="f-reg-i f-mgray">
                                Netflix es un servicio de streaming que les permite a sus clientes ver una gran variedad
                                de series, películas y documentales galardonados (¡y mucho más!) en miles de
                                dispositivos conectados a Internet. Con Netflix por medio de la Factura Claro podrás
                                disfrutar del servicio pagándolo directamente en tu factura mensual. Todas tus cuentas
                                en un solo sitio.
                            </span>
                        </div>
                        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 text-center h-mtop">
                            <img width="100%" src="../assets/images/netfix-stock2.jpg">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="basicrow m-top-i graybg">
            <div class="container">
                <div class="basicrow m-top m-bott">
                    <div class="basicrow f-big roboto-l f-black">
                        &#191;Necesitas Ayuda&#63;
                    </div>
                    <div class="basicrow m-top-i">
                        <div class="row refdef">
                            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                                <div class="basicrow text-center">
                                    <img width="100%" class="ref-icons" src="../assets/images/netflixicon1.png">
                                </div>
                                <div class="basicrow f-black roboto-r f-reg text-center m-top">
                                    <div class="basicrow f-bmed roboto-b">
                                        T&eacute;rminos y Condiciones
                                    </div>
                                    <div class="basicrow m-top">
                                        Consulta en esta sección los Términos & Condiciones para el servicio de Netflix
                                        en la factura de Claro.
                                        <br /><br />
                                        <a href="/netflix_terms" class="linkdefs">Ver Detalle&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i></a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 hrefmtop">
                                <div class="basicrow text-center">
                                    <img width="100%" class="ref-icons" src="../assets/images/ico_preguntasFrecuentes.png">
                                </div>
                                <div class="basicrow f-black roboto-r f-reg text-center m-top">
                                    <div class="basicrow f-bmed roboto-b">
                                        Preguntas Frecuentes
                                    </div>
                                    <div class="basicrow m-top">
                                        Te invitamos a que visites esta sección para que aclares algunas de las dudas
                                        más comunes.
                                        <br /><br />
                                        <a href="/netflix_questions" ui-sref="netflix_questions" class="linkdefs">Ver Detalle&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i></a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 hrefmtop">
                                <div class="basicrow text-center">
                                    <img width="100%" class="ref-icons" src="../assets/images/netflixicon3.png">
                                </div>
                                <div class="basicrow f-black roboto-r f-reg text-center m-top">
                                    <div class="basicrow f-bmed roboto-b">
                                        Soporte T&eacute;cnico
                                    </div>
                                    <div class="basicrow m-top">
                                        ¿Cómo obtener apoyo técnico por parte de Netflix y/o Claro Puerto Rico si pagas
                                        tu servicio de Netflix a través de la factura de Claro?
                                        <br /><br />
                                        <a href="/netflix_support" class="linkdefs">Ver Detalle&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="basicrow roboto-r f-med f-black">
            <div class="container m-top-i m-bott">
                <div class="row m-top-i m-bott">
                    <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 text-center">
                        <img width="100%" class="n-supp-icon" src="../assets/images/netflixicon4.png">
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-10 col-lg-10 text-left">
                        <div class="basicrow">
                            <div class="row">
                                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <div class="basicrow f-big roboto-l">
                                        Cont&aacute;ctanos
                                    </div>
                                </div>
                                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 m-top">
                                    <div class="basicrow f-bmed roboto-b">
                                        Horario de Servicio al Cliente
                                    </div>
                                    <div class="basicrow f-med line-def-i m-top-ii">
                                        Lunes a Viernes: 8:00 a.m - 7:00 p.m<br />
                                        S&aacute;bados y Domingos: 8:00 a.m - 5:00 p.m<br />
                                        D&iacute;as Feriados: 8:00 a.m - 5:00 p.m
                                    </div>
                                </div>
                                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 m-top">
                                    <div class="basicrow h-mtop f-bmed roboto-b">
                                        Tel&eacute;fonos de Contacto
                                    </div>
                                    <div class="basicrow f-med line-def-i m-top-ii">
                                        Servicio al Cliente: 787-775-0000
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="basicrow graybg">
            <div class="container">
                <div class="m-top-i m-bott">
                    <div class="basicrow text-center f-black f-btitle">
                        ¿Olvidaste tu Contraseña?
                    </div>
                </div>
                <div class="basicrow m-top-ii ">
                    <div class="row">
                        <div class="boton-desc">
                            <a href="https://www.netflix.com/co/LoginHelp" target="_blank" rel="noopener noreferrer" class="btns blue vcenter">
                                <span class="tabcell">
                                    Recuperar Contraseña de Netflix&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</div>
